/**
 * Получает массив закрашенности звезд
 * пример: [1, 1, 0.5, 0, 0] (2 полность закрашены, 1 на половину и 2 пустых)
 */
export function getUnits(count: number, value: number): number[] {
  const units: number[] = [];

  const oneUnitWeight = 1 / count;
  let weight = 0;

  for (let i = 0; i < count; i++) {
    let unitValue = (value - weight) / oneUnitWeight;
    if (unitValue < 0) {
      unitValue = 0;
    }
    if (unitValue > 1) {
      unitValue = 1;
    }
    weight += oneUnitWeight;
    units.push(unitValue);
  }

  return units;
}
